// src/components/common/RenderCalendlyLinks.tsx
import React from "react";
import { InlineWidget } from "react-calendly";
import { type CalendlySchedule } from "../../types/product.types";
import { cn } from "../../utils/cn";
// import { CalendlyInlineWidget } from "./Calendly";

interface RenderCalendlyLinksProps {
    stock?: boolean;
    calendly_schedule: CalendlySchedule[];
}

const RenderCalendlyLinks = ({
    stock = false,
    calendly_schedule,
}: RenderCalendlyLinksProps) => {
    if (!stock || !calendly_schedule || calendly_schedule.length === 0) {
        return null;
    }

    return (
        <div className="mt-10 space-y-8">
            {calendly_schedule.map((schedule, idx) => (
                <div
                    key={schedule.id}
                    className={cn(
                        idx === calendly_schedule.length - 1
                            ? ""
                            : "border-b-2 pb-8",
                    )}
                >
                    <div className="mb-6 border-l-4 border-slate-700 pl-4">
                        <h3 className="mb-2 text-2xl font-semibold leading-tight text-slate-800">
                            Sessió amb {schedule.name}
                        </h3>

                        <p className="text-lg font-medium text-slate-600">
                            {schedule.position}{" "}
                        </p>

                        {schedule.description && (
                            <p className="mt-1 text-base font-medium text-ccyan-dark">
                                {schedule.description}
                            </p>
                        )}
                    </div>

                    <div className="mb-6 flex items-start gap-2 pl-4">
                        <svg
                            className="mt-1.5 h-5 w-5 flex-shrink-0 text-slate-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                        </svg>

                        <div>
                            <span className="text-sm font-medium uppercase tracking-wide text-slate-500">
                                Ubicació
                            </span>
                            <p className="mt-0.5 text-base text-slate-700">
                                {schedule.location}
                            </p>
                        </div>
                    </div>

                    <InlineWidget
                        url={schedule.link}
                        styles={{ height: "700px" }}
                        pageSettings={{
                            hideEventTypeDetails: true,
                            hideLandingPageDetails: true,
                            hideGdprBanner: true,
                            primaryColor: "00A3FF",
                        }}
                    />

                    {/*<CalendlyInlineWidget
                        url={schedule.link}
                        height={700}
                        className="!mt-10"
                    />*/}
                </div>
            ))}
        </div>
    );
};

export default RenderCalendlyLinks;
